export const _REQUEST = '_REQUEST';
export const _SUCCESS = '_SUCCESS';
export const _FAILURE = '_FAILURE';

export const MODEL_NAV_FLG = 'MODEL_NAV_FLG'

export const RETURN_RESULT = 'RETURN_RESULT'
export const REQUESTING = 'REQUESTING'
export const HEADER_TITLE = 'HEADER_TITLE'
export const TOUCH_START = 'TOUCH_START'
export const TOUCH_MOVE = 'TOUCH_MOVE'

export const TOUCH_START_X = 'TOUCH_START_X'
export const TOUCH_START_Y = 'TOUCH_START_Y'

export const TOUCH_IS_UP = 'TOUCH_IS_UP'
export const TOUCH_IS_LEFT = 'TOUCH_IS_LEFT'

export const MODEL_TYPE = 'MODEL_TYPE'
export const MODEL_EXIT = 'MODEL_EXIT'

export const DICT_LIST = 'DICT_LIST'

export const UPDATE_INFO_STATE = 'UPDATE_INFO_STATE'
export const DEL_INFO_STATE = 'DEL_INFO_STATE'


// WEBPACK FOOTER //
// ./src/vuex/actionType/state-type.js